<template>
  <el-form
    inline
    label-width="120px"
    label-position="right"
    label-suffix="："
    :rules="RULES"
  >
    <page-block title="基本信息" name="货主详情">
      <el-form-item label="货主类型" prop="shipperType">
        <span>个人</span>
      </el-form-item>
      <el-row>
        <el-col :span="10">
          <el-form-item label="姓名" prop="name">
            <span>{{ form.contacts }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="货主编码" prop="code">
            <span>{{ form.customerCode }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="手机号" prop="phone">
            <span>{{ form.telPhone }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="身份证号" prop="code">
            <span>{{ form.ext && form.ext.identityNo }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </page-block>
  </el-form>
</template>

<script>
import PageBlock from '@/components/PageBlock/index.vue';

export default {
  components: {
    PageBlock,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      RULES: {
        name: [
          { required: true },
        ],
        phone: [
          { required: true },
        ],
      },
    };
  },
};
</script>
